import React from 'react';
import { BatteryWarning, CheckCircle2 } from 'lucide-react';
export function ProblemSolution() {
  return <section className="py-16 px-4 bg-white" data-id="element-89">
      <div className="max-w-4xl mx-auto" data-id="element-90">
        {/* The Problem */}
        <div className="text-center mb-16" data-id="element-91">
          <h2 className="text-3xl md:text-5xl font-black mb-8 text-slate-900 leading-tight" data-id="element-92">
            La parte más agotadora de enseñar no es dar clases…{' '}
            <span className="highlight-yellow" data-id="element-93">
              es preparar TODO desde cero.
            </span>
          </h2>

          <p className="text-xl md:text-2xl text-slate-700 mb-10 font-medium" data-id="element-94">
            Ser docente hoy significa llegar cansado a casa y todavía tener que:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto mb-12" data-id="element-95">
            {['planificar contenidos', 'preparar diapositivas', 'buscar actividades', 'diseñar evaluaciones', 'organizar clases', 'resumir teoría', 'pensar cómo mantener atento al curso'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-red-50 p-4 rounded-lg border border-red-100" data-id="element-96">
                <BatteryWarning className="text-red-500 shrink-0" size={24} data-id="element-97" />
                <span className="font-semibold text-slate-800 text-lg" data-id="element-98">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-2xl font-bold text-slate-900 mb-4" data-id="element-99">
            Y mientras más cursos tenés…
          </p>
          <p className="text-3xl font-black text-red-600 uppercase" data-id="element-100">
            más tiempo perdés organizando materiales.
          </p>
        </div>

        {/* The Transition / Solution */}
        <div className="bg-sky-50 border-2 border-sky-200 rounded-2xl p-8 md:p-12 text-center shadow-lg" data-id="element-101">
          <h3 className="text-xl md:text-2xl font-bold mb-4 text-slate-700" data-id="element-102">
            La mayoría de docentes no necesita trabajar más.
            <br data-id="element-103" />
            Necesita un sistema que le ahorre tiempo.
          </h3>

          <div className="w-24 h-1 bg-sky-300 mx-auto my-8" data-id="element-104"></div>

          <p className="text-lg md:text-xl font-medium mb-4 text-slate-700" data-id="element-105">
            Por eso creamos el
          </p>
          <h2 className="text-3xl md:text-5xl font-black text-sky-700 mb-8 uppercase leading-tight" data-id="element-106">
            Manual Académico de Geografía para Docentes
          </h2>

          <p className="text-2xl md:text-3xl font-black text-green-600 mb-8" data-id="element-107">
            No es un simple PDF.
          </p>
          <p className="text-lg md:text-xl mb-8 text-slate-700" data-id="element-108">
            Es un sistema académico completo diseñado para que el docente tenga:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto text-left" data-id="element-109">
            {['contenido organizado', 'clases preparadas', 'recursos visuales', 'actividades dinámicas', 'evaluaciones listas', 'trabajos prácticos'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg border border-sky-200 shadow-sm" data-id="element-110">
                <CheckCircle2 className="text-green-500 shrink-0" size={24} data-id="element-111" />
                <span className="font-bold text-lg text-slate-800" data-id="element-112">{item}</span>
              </div>)}
          </div>

          <p className="mt-8 text-lg font-bold text-sky-700 uppercase tracking-widest" data-id="element-113">
            Todo estructurado para secundaria.
          </p>
        </div>
      </div>
    </section>;
}